<script setup lang="ts">
import { onMounted, ref } from 'vue'
import AlertDialog from './components/layout/AlertDialog.vue'
import Spinner from './components/layout/Spinner.vue'
import SplashScreen from './components/layout/SplashScreen.vue'
import { waitForAuthBootstrap } from './utils/liff'

// Same promise the auth guard awaits before allowing a protected route
// through — keeps the splash up for exactly as long as the guard would
// otherwise leave the screen blank.
const isBootstrapping = ref(true)

onMounted(async () => {
  await waitForAuthBootstrap()
  isBootstrapping.value = false
})
</script>

<template>
  <Transition name="fade">
    <SplashScreen v-if="isBootstrapping" />
  </Transition>
  <router-view v-slot="{ Component }">
    <Suspense>
      <component :is="Component" />
      <template #fallback>
        <div>Loading...</div>
      </template>
    </Suspense>
  </router-view>
  <AlertDialog />
  <Spinner />
</template>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
